import XLSX from 'xlsx';

export default {
  methods: {
    exportXls(rptCuentas) {
      // let empresa = this.$store.getters['user/empresa'];

      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Gastos",
        Subject: "ResumenGastos",
        Author: 'SGC',
        CreatedDate: new Date()
      };

      let data = [
        [
          `Desde: ${this.$options.filters.fecha(rptCuentas.fechaDesde)}`, 
        ],
      ];

      data.push([
        `Hasta: ${this.$options.filters.fecha(rptCuentas.fechaHasta)}`, 
      ])

      data.push([]);
      data.push([]);

      data.push([
          'Cuenta', 
          'Rubro', 
          'Subrubro', 
          'Proveedor', 
          'Importe'
      ]);

      if (rptCuentas.cuentas) {
        rptCuentas.cuentas.forEach(item => {
          let cuenta = '';
          let rubro = '';
          let subrubro = '';
          let proveedor = '';
          let importe = item.monto;

          if (item.proveedorId != 0) {
            proveedor = item.nombre.trim();
          } else if (item.subrubroId != 0) {
            subrubro = item.nombre.trim();
          } else if (item.rubroId != 0) {
            rubro = item.nombre.trim();
          } else {
            cuenta = item.nombre.trim();
          }

          data.push([
            cuenta,
            rubro,
            subrubro,
            proveedor,
            importe
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "ResumenGastos");
      XLSX.writeFile(wb, "resumen_gastos.xlsx");

      return;
    }
  }
}